import { ViewModel,View } from "../../index";
import { Binder, BinderPropertyDescriptor, IBinding, IConverter } from "../../binding/binding";
class BindingPrototypeParser{
    private static parser:any;
    public static Parse(expressionText:string):{type:string,path:string,converter:string,reverseConverter:string,viewSelector:string,staticValue:string}{
        expressionText = expressionText.trim();
        expressionText = expressionText.substring(1,expressionText.length-1);
        let expression = this.parser.parse(expressionText);
        return {
            type:expression.type,
            path:expression.path,
            converter:expression.Converter,
            reverseConverter:expression.ReverseConverter,
            viewSelector:expression.ViewSelector,
            staticValue : expression.value
        }
    }
    public static ParseBindingNoImplicitBindings(expressionText:string):BindingPrototype{
        expressionText = expressionText.trim();
        expressionText = expressionText.substring(1,expressionText.length-1);
        let expression = this.parser.parse(expressionText);
        switch(expression.type){
            case 'binding':
                let binding = new SingleBindingPrototype();
                binding.source = expression.path;
                binding.converterName = expression.Converter;
                binding.reverseConverterName = expression.ReverseConverter;
                binding.viewSelectorName = expression.ViewSelector;
                return binding;
            case 'multibinding':
                let multibinding = new MultiBindingPrototype();
                multibinding.sources = expression.path;
                multibinding.converterName = expression.Converter;
                multibinding.reverseConverterName = expression.ReverseConverter;
                return multibinding;
            case 'static':
                let staticBinding = new StaticBindingPrototype();
                staticBinding.value = expression.value;
                return staticBinding;
            default:
                return null;
        }
    }
    public static ParseBinding(expressionText:string):BindingPrototype{
        if(BindingPrototypeParser.IsBindingExpression(expressionText)){
            return BindingPrototypeParser.ParseBindingNoImplicitBindings(expressionText);
        }else{
            let staticBinding = new StaticBindingPrototype();
            staticBinding.value = expressionText;
            return staticBinding;
        }
    }
    public static IsBindingExpression(expressionText:string):boolean{
        return expressionText.trim().startsWith("{") && expressionText.trim().endsWith("}");
    }
    private static _staticConstructor= (()=>{
        BindingPrototypeParser.parser=require('./bindingExpressionParser.js');
    })();
    
}
class BindingConverterResolver{
    public static converterRepository:object[]=[];
    
    private static resolveFunction(name:string,source:Object):Function{
        return source[name];
    }

    public static resolveBindingFunction(name:string,source:Object):Function{
        if(name==null || name=='')
            return null;
        let result = this.resolveFunction(name,source);
        if(result==null){
            for(let i=this.converterRepository.length-1;result==null && i>=0;i--){
                let repo = this.converterRepository[i];
                result = this.resolveFunction(name,repo);
            }
        }
        if(result!=null)
            result.bind(source);
        return result;
    }
}
abstract class BindingPrototype{
    abstract create(source:any,dest:BinderPropertyDescriptor):IBinding;
    getSources():string[]{
        return [];
    }
    getViewSelectorFunction(owner):(viewmodel:ViewModel)=>View<ViewModel>{
        return null;
    }

    abstract getStaticValue();
}

class SingleBindingConverter implements IConverter{
    public forward:Function;
    public reverse:Function;
    convert(...sources: any[]) {
        return this.forward==null ? sources[0] : this.forward(sources[0]);
    }
    convertBack(value: any, ...sources: BinderPropertyDescriptor[]): any[] {
        return this.reverse==null ? [value] : [this.reverse(value)];
    }
}
class MultiBindingConverter implements IConverter{
    public forward:Function;
    public reverse:Function;
    convert(...sources: any[]) {
        return this.forward==null ? Binder.OmitChangeValue : this.forward(sources);
    }
    convertBack(value: any, ...sources: BinderPropertyDescriptor[]): any[] {
        return this.reverse==null ? sources.map(x=>Binder.OmitChangeValue) : this.reverse(value);
    }
}

class SingleBindingPrototype extends BindingPrototype{
    public source:string;
    public converterName:string;
    public reverseConverterName:string;
    public viewSelectorName:string;
    private viewSelectorFunction: (viewModel: ViewModel) => View<ViewModel>;
    
    private getDefaultView(viewModel:ViewModel):View<ViewModel>{
        return viewModel.GetDefaultView(); 
    }

    private findViewSelectorFunction(source:any):(viewModel:ViewModel)=>View<ViewModel>{
        let viewSelectorFunction = BindingConverterResolver.resolveBindingFunction(this.viewSelectorName,source);
        if(viewSelectorFunction==null){
            return this.getDefaultView; 
        }else {
            return <(viewModel:ViewModel)=>View<ViewModel>>viewSelectorFunction;
        }
    }
    getSources():string[]{
        return [this.source];
    }
    getViewSelectorFunction(owner):(viewmodel:ViewModel)=>View<ViewModel>{
        if(this.viewSelectorFunction!=null)
            return this.viewSelectorFunction.bind(owner);
        else
            return this.findViewSelectorFunction(owner).bind(owner); 
        return null;
    }
    create(source: any, dest: BinderPropertyDescriptor): IBinding {
        let converter : SingleBindingConverter = new SingleBindingConverter();
        converter.forward =BindingConverterResolver.resolveBindingFunction(this.converterName,source); 
        converter.reverse = BindingConverterResolver.resolveBindingFunction(this.reverseConverterName,source);
        if(converter.forward && converter.reverse==null){
            converter.reverse=(function(a,...params){return Binder.OmitChangeValue;}).bind(source);
        }
        this.viewSelectorFunction = this.findViewSelectorFunction(source);

        return Binder.createBinding(dest,converter,new BinderPropertyDescriptor(source,this.source));
    }
    getStaticValue() {
        return undefined;
    }    
}
class MultiBindingPrototype extends BindingPrototype{
    public sources:string[];
    public converterName:string;
    public reverseConverterName:string;

    create(source: any, dest: BinderPropertyDescriptor): IBinding {
        let converter : MultiBindingConverter = new MultiBindingConverter();
        converter.forward =BindingConverterResolver.resolveBindingFunction(this.converterName,source); 
        converter.reverse = BindingConverterResolver.resolveBindingFunction(this.reverseConverterName,source);
        if(converter.forward && converter.reverse==null){
            converter.reverse=(function(a,...params){return params.map(x=>Binder.OmitChangeValue);}).bind(source);
        }
        return Binder.createBinding(dest,converter,...this.sources.map(x=> new BinderPropertyDescriptor(source,x)));
    }
    getSources():string[]{
        return this.sources;
    }
    getStaticValue() {
        return undefined;
    }
}
class StaticBindingPrototype extends BindingPrototype{
    public value:string;
    
    create(source: any, dest: BinderPropertyDescriptor): IBinding {
        dest.source[dest.propertyName]=this.value;
        return Binder.createEmptyBinding();
    }
    getStaticValue():string {
        return this.value;
    }
}

export {BindingPrototypeParser,BindingConverterResolver,BindingPrototype}
